window.updatePriceDisplay = function(Value) {
    if (isNaN(Value) || Value <= 0) {
        console.warn('Invalid quantity:', Value);
        return;
    }

    const mainAddToBasketContainer = document.querySelector('.main-add-to-basket');
    const priceSections = document.querySelectorAll('.price_quantity_wrapper .price__container, product-info .price__container, .main-add-to-basket .price__container');

    const discountTwo = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-two')) || 0 : 0;
    const discountThree = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-three')) || 0 : 0;

    const updateQuantityInputs = (Value) => {
        document.querySelectorAll('.price_quantity_wrapper .quantity__input').forEach(input => input.value = Value);
        document.querySelectorAll('.updated-product-quantity').forEach(input => input.setAttribute("value", Value));
        document.querySelectorAll('.price-per-item__container .quantity__button').forEach(button => {
           if (Value >= 2) {
            button.classList.remove('disabled');
          }
        });
};

    const getDiscountedPrice = (regularPrice, Value) => {
        if (Value > 1 && Value < 3) return regularPrice * (1 - discountTwo / 100);
        if (Value > 2) return regularPrice * (1 - discountThree / 100);
        return regularPrice;
    };

    priceSections.forEach(priceContainer => {
        const regularPrice = parseFloat(priceContainer.getAttribute('data-regular-price')) / 100;
        const compareAtPrice = parseFloat(priceContainer.getAttribute('data-compare-price')) / 100;

        let updatedRegularPrice = getProductPriceBasedOnQuantity(Value, regularPrice);
        let updatedCompareAtPrice = compareAtPrice ? getProductPriceBasedOnQuantity(Value, compareAtPrice) : null;
        let updatedDiscountAtPrice = updatedRegularPrice;

        // Apply discounts if no compare-at price
        if (!updatedCompareAtPrice) updatedDiscountAtPrice = getDiscountedPrice(updatedRegularPrice, Value);

        priceContainer.innerHTML = '';

        if (updatedCompareAtPrice) {
            priceContainer.innerHTML = `
                <span class="price-item price-item--compare">${formatPrice(updatedRegularPrice)}</span>
                <span class="price-item price-item--regular">${formatPrice(updatedCompareAtPrice)}</span>
            `;
        } else if (updatedDiscountAtPrice < updatedRegularPrice) {
            priceContainer.innerHTML = `
                <s class="price-item price-item--regular">${formatPrice(updatedRegularPrice)}</s>
                <span class="price-item price-item--sale price-item--last">${formatPrice(updatedDiscountAtPrice)}</span>
            `;
        } else {
            priceContainer.innerHTML = `
                <div class="price__regular">
                    <span class="price-item price-item--regular">${formatPrice(updatedRegularPrice)}</span>
                </div>
            `;
        }

        updateQuantityInputs(Value);
    });
};

document.querySelectorAll('label.bulk-buy').forEach(label => {
    label.addEventListener('click', function() {
        const qty = this.getAttribute('data-qty');
        window.updatePriceDisplay(qty);
    });
});

function formatPrice(price) {
    return `€${price.toFixed(2)}`;
}

function getProductPriceBasedOnQuantity(Value, unitPrice) {
    return unitPrice * Value;
}
